import { render, staticRenderFns } from "./WsataReports.vue?vue&type=template&id=b08aace4&"
import script from "./WsataReports.vue?vue&type=script&lang=js&"
export * from "./WsataReports.vue?vue&type=script&lang=js&"
import style0 from "./WsataReports.vue?vue&type=style&index=0&id=b08aace4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports